const timeOut = resolve => require(['@/components/time-out'], resolve) //请求超时页面

export default [
  {
    path: 'preview/:taskId',
    component (resolve) {
      require(['@/components/student/homework/detail'], resolve)
    },
    meta: {
      title: '预习'
    }
  },
  {
    path: 'detail/:taskId',
    component (resolve) {
      require(['@/components/student/homework/detail'], resolve)
    },
    meta: {
      title: '作业详情'
    }
  },
  {
    path: 'group/:taskId',
    component (resolve) {
      require(['@/components/student/homework/group'], resolve)
    },
    meta: {
      title: '小组作业'
    }
  },
  {
    path: 'disc/:taskId',
    component (resolve) {
      require(['@/components/student/homework/group'], resolve)
    },
    meta: {
      title: '小组研讨'
    }
  },
  {
    path: 'group/comment/:taskId/:commentId/:groupId',
    component (resolve) {
      require(['@/components/student/homework/group-comment'], resolve)
    },
    meta: {
      title: '小组交流'
    }
  },

  {
    path: 'attach/list/:taskId/:groupId',
    component (resolve) {
      require(['@/components/student/homework/attach-list'], resolve)
    },
    meta: {
      title: '任务附件'
    }
  },
  {
    path: 'remark/:taskId/:referId/:referType',
    component (resolve) {
      require(['@/components/student/homework/remark'], resolve)
    },
    meta: {
      title: '批注'
    }
  },
  {
    path: 'upload/:taskId/:groupId',
    component (resolve) {
      require(['@/components/student/homework/upload-pc'], resolve)
    },
    meta: {
      title: '电脑上传文件'
    }
  },
  {
    path: 'task-answer-detail/:type/:subId/:classId',
    component (resolve) {
      require(['@/components/student/homework/online/taskAnswerDetail'], resolve)
    },
    meta: {
      title: '作答详情'
    }
  },
  {
    path: 'onlineTask/:taskId/:classId',
    component (resolve) {
      require(['@/components/student/homework/online/task'], resolve)
    },
    meta: {
      keepAlive: true,
      title: '线上活动作业'
    }
  },
  {
    path: '/timeout',
    component: timeOut
  },
  {
    path: 'onlineUpload/:taskId/:groupId',
    component (resolve) {
      require(['@/components/student/homework/online/upload-pc-by-number'], resolve)
    },
    meta: {
      title: '上传附件'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/student/homework.js